import React from 'react';
import { Link } from 'react-router-dom';

export default function DataTable({
    columns,
    data,
    isLoading,
    onEdit,
    onDelete,
    actions = true,
    onRowClick,
}) {
    if (isLoading) {
        return (
            <div className="w-full h-48 flex items-center justify-center text-gray-400">
                Loading...
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="w-full h-48 flex items-center justify-center text-gray-500 bg-[#1a1025] rounded-xl border border-white/5">
                No data available
            </div>
        );
    }

    return (
        <div className="bg-[#1a1025] rounded-xl border border-white/5 shadow-xl overflow-x-auto custom-scrollbar">
            <table className="w-full text-left text-sm text-gray-400">
                <thead className="bg-[#241b35] text-xs uppercase text-gray-300 sticky top-0 z-10 shadow-lg">
                    <tr>
                        {columns.map((col, idx) => (
                            <th key={idx} className="px-6 py-4 font-semibold tracking-wider">
                                {col.header}
                            </th>
                        ))}
                        {actions && <th className="px-6 py-4 text-right">Actions</th>}
                    </tr>
                </thead>
                <tbody className="divide-y divide-white/5">
                    {data.map((item, rowIdx) => (
                        <tr
                            key={rowIdx}
                            className={`transition-colors ${onRowClick ? 'cursor-pointer hover:bg-[#2a203f]/80' : 'hover:bg-[#2a203f]'}`}
                            onClick={() => onRowClick && onRowClick(item)}
                        >
                            {columns.map((col, colIdx) => (
                                <td key={colIdx} className="px-6 py-4 whitespace-nowrap">
                                    {col.render ? col.render(item) : item[col.accessor]}
                                </td>
                            ))}
                            {actions && (
                                <td className="px-6 py-4 text-right whitespace-nowrap">
                                    <div className="flex items-center justify-end space-x-3">
                                        {onEdit && (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onEdit(item);
                                                }}
                                                className="text-blue-400 hover:text-blue-300 transition-colors p-1 hover:bg-blue-900/30 rounded"
                                                title="Edit"
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                </svg>
                                            </button>
                                        )}
                                        {onDelete && (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onDelete(item);
                                                }}
                                                className="text-red-400 hover:text-red-300 transition-colors p-1 hover:bg-red-900/30 rounded"
                                                title="Delete"
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
